//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectBody.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ApproximateSheetbodyOption",1,0],[0,"BasePlane",1,"Plane",0],[0,"BaseThickness",1,0],[0,"BaseWidth",1,0],[0,"BeltThickness",1,0],[0,"CoreDrawPunchOption",1,0],[0,"DeckThickness",1,0],[0,"ExactSheetbodyOption",1,0],[1,"FlangeProfile",0,"Section",0],[0,"MachiningAllowance",1,0],[1,"MainWallCenterLine",0,"Section",0],[1,"PunchCurve",0,"SelectNXObjectList",0],[0,"ReliefAngle",1,0],[0,"ReliefDistance",1,0],[1,"SheetBody",0,"SelectBody",0],[1,"SheetBodyDeck",0,"SelectBody",0],[0,"TfeatureSet",1,"Features.Feature",0],[0,"WallThickness",1,0]],[],[]];
SPLM.Tooling.DieDesDrawPunchBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieDesDrawPunchBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;